import { Link, useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import { addPost, checkNomPoste } from '../../../../services/RHService/PostService';
import Swal from 'sweetalert2';
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const AddPost = () => {
  const navigate = useNavigate();
  const [nompostError, setNompostError] = useState('');
  const [nomPost, setNomPost] = useState("");
  const [nb_hrs_mois, setNb_hrs_mois] = useState("");
  // const [formData, setFormData] = useState({
  //   nomPost: "",
  //   nb_hrs_mois: 0,
  // });
  const onChangeNamePostHandler = (event) => {
    setNomPost(event.target.value);
  };
  const onChangeNb_hrs_moisHandler = (event) => {
    setNb_hrs_mois(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    checkNomPoste(nomPost, getCurrentUserId()).then((response) => {
      if (response.data.success) {
        setNompostError("Nom de Poste déja existe");
      } else {
        try {
          let formData = {
            idUserCreation: getCurrentUserId(),
            nomPost: nomPost,
            nb_hrs_mois: nb_hrs_mois,
          }
          addPost(formData).then((response) => {
            console.log("addPost", response)
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Poste inséré avec succès',
              showConfirmButton: false,
              timer: 1500
            });
          })

          setTimeout(() => {
            navigate(`/postList`);
          }, 2000);

        } catch (error) {
          console.log(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: "Une erreur s'est produite lors de l'insertion"
          });
        }

      }
      console.log("response", response)
    })
    // if (checknomPostExist) {
    //   
    // } else {
    //   setNompostError('');
    // }
    // if (!checknomPostExist) {


    // }
  }
  return (
    <section className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">  Ajouter un post</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><i class="fa-solid fa-house"></i></li>
                <li className="breadcrumb-item"><Link to="/" style={{ color: "black" }}>Home</Link></li>
                <li className="breadcrumb-item active"><Link to="/postList" style={{ color: "black" }}>Liste des postes</Link></li>
                <li className="breadcrumb-item active">Ajouter un post</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div class="card-header">
                  <h4 class="card-title">Ajouter un post</h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="form-group">
                          <label htmlFor="inputName">Post</label>
                          <input
                            placeholder="Ajouter libellé "
                            onChange={onChangeNamePostHandler}
                            type="text"
                            id="inputName"
                            className="form-control"
                          />
                        </div>
                        {/* <div className="form-group">
                          <label for="exampleInputPassword1">Post</label>
                          <input type="text" className="form-control form-control-border"
                            value={formData.nomPost} onChange={handleInputChange}
                            name="nomPost" placeholder="Post" />
                        </div> */}
                        {nompostError && <p style={{ color: 'red' }}>{nompostError}</p>}

                        {/* <div className="form-group">
                          <label for="exampleInputPassword1">Nombre d'heures/mois</label>
                          <input type="text" className="form-control form-control-border" value={formData.nb_hrs_mois} onChange={handleInputChange} name="nb_hrs_mois" placeholder="nombre d'heure" />
                        </div> */}
                        <div className="form-group">
                          <label htmlFor="inputName">Nombre d'heures/mois</label>
                          <input
                            placeholder="Ajouter Nombre d'heures par mois "
                            onChange={onChangeNb_hrs_moisHandler}
                            type="number"
                            id="inputName"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button type="submit" className="btn btn-dark col-md-3 float-right" style={{ "width": "auto" }}>Confirmer</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}
export default AddPost;